import { render, staticRenderFns } from "./TabelaFreteExportar.vue?vue&type=template&id=c73e3934"
import script from "./TabelaFreteExportar.vue?vue&type=script&lang=js"
export * from "./TabelaFreteExportar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports